import { apiCall, baseUrl, extendUrl } from './config';
import { parseQueryParams } from '../../utils/queryParams';
import { shouldUseMock } from '../../utils/common';
import {
  favoriteNodeActionMock, getAgendaPlannableListMock, getAgendaPlannedListMock, getSelectionMock, getCollectionMock, getAcademyMock, getFavoritesMock
} from './mock';

export default {
  getPlannableList: (filters) => {
    if (shouldUseMock()) {
      return getAgendaPlannableListMock();
    }
    return apiCall(`${baseUrl}${extendUrl}integration/plannablelist${parseQueryParams(filters)}`, 'GET');
  },
  getPlannedList: (filters) => {
    if (shouldUseMock()) {
      return getAgendaPlannedListMock();
    }
    return apiCall(`${baseUrl}${extendUrl}integration/agenda/planned_list${parseQueryParams(filters)}`, 'GET');
  },
  getMandatoryTrainingList: (filters) => {
    if (shouldUseMock()) {
      return getSelectionMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/course${parseQueryParams(filters)}`, 'GET');
  },
  getOptionalCoursesList: (filters) => {
    if (shouldUseMock()) {
      return getCollectionMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/course${parseQueryParams(filters)}`, 'GET');
  },
  getAcademyList: (filters) => {
    if (shouldUseMock()) {
      return getAcademyMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/course${parseQueryParams(filters)}`, 'GET');
  },
  getFavoriteList: (filters) => {
    if (shouldUseMock()) {
      return getFavoritesMock();
    }
    return apiCall(`${baseUrl}${extendUrl}favourite${parseQueryParams(filters)}`, 'GET');
  },
  setFavourite: (payload) => {
    if (shouldUseMock()) {
      return favoriteNodeActionMock();
    }
    return apiCall(`${baseUrl}${extendUrl}user/node_action`, 'POST', payload);
  }
};
